<div class="notification-message" [ngClass]="severityClass">
  <div>
    {{ messageText }} <a *ngIf="actionLink" href="{{ actionLink }}">{{ actionText }}</a>
  </div>
</div>
